import { render, staticRenderFns } from "./CombinationOverview.vue?vue&type=template&id=3c1afab6&scoped=true&lang=html&"
import script from "./CombinationOverview.vue?vue&type=script&lang=js&"
export * from "./CombinationOverview.vue?vue&type=script&lang=js&"
import style0 from "./CombinationOverview.vue?vue&type=style&index=0&id=3c1afab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1afab6",
  null
  
)

export default component.exports